import React, { createContext, useContext, useState } from 'react';
import {
  AlertCircle,
  ArrowRight,
  CheckCircle,
  Link as LinkLucide,
  Lock,
  Plus,
  Trash2
} from 'lucide-react';

function createLucideIcon(IconComponent, defaultSize = 16) {
  return function ChakraIcon({ boxSize, color, ...props }) {
    const size =
      typeof boxSize === 'number'
        ? boxSize * 4
        : typeof boxSize === 'string'
          ? parseInt(boxSize, 10) * 4 || defaultSize
          : defaultSize;
    return <IconComponent size={size} color={color} {...props} />;
  };
}

export const LinkIcon = createLucideIcon(LinkLucide);
export const LockIcon = createLucideIcon(Lock);
export const CheckCircleIcon = createLucideIcon(CheckCircle);
export const WarningIcon = createLucideIcon(AlertCircle);
export const ArrowForwardIcon = createLucideIcon(ArrowRight);
export const AddIcon = createLucideIcon(Plus);
export const DeleteIcon = createLucideIcon(Trash2);
